import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppContextService } from '../service/app-context.service';

@Injectable()
export class OrigemInterceptor implements HttpInterceptor {

  constructor(private appContext: AppContextService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const origem = this.appContext.getOrigem();

    if (origem) {
      const cloned = req.clone({
        headers: req.headers.set('client-type', origem)
      });
      return next.handle(cloned);
    }

    return next.handle(req);
  }
}